import TimeSheet from "molecules/TimeSheet";
import React, { useEffect, useState } from "react";
import LeftIcon from "assets/icons/UI/left.svg";
import RightIcon from "assets/icons/UI/right.svg";
import Button from "atoms/Button";
import { DatePicker, Form, Spin, notification } from "antd";
import { useFetch } from "hooks/useFetch";
import queryKeys from "common/queryKey";
import { ClickAwayListener } from "@mui/material";
import { connect, useDispatch, useSelector } from "react-redux";
import {
  getActualSummaryData,
  getCachedTimesheets,
  getHigherOfficials,
  getUserInfo,
  getUserList,
} from "redux/selectors";
import { useMutate } from "hooks/useMutate";
import { useUpdate } from "hooks/useUpdate";
import { useQueryClient } from "react-query";
import useWeekData, {
  generateTimesheetWeek,
  periodToDate,
} from "./useWeekData";
import { ConfigProvider } from "antd";
import en_GB from "antd/lib/locale-provider/en_GB";
import moment from "moment";
import "moment/locale/en-gb";
import { apiInstance } from "config/baseUrl";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import TimeSheetOverView from "./TimeSheetOverView";
import TimeSheetFooterHint from "./TimeSheetFooterHint";
import { ONGOING, PENDING, WITHDRAWN, DRAFT } from ".";
import useTimesheetfns from "./useTimesheetfns";
import { toggleProcessingModal } from "redux/actions";
import { CALL_API } from "common/API";
import { getClientid, getUserRoleId } from "redux/selectors";
import { getEmailsByRole } from "utils/functions";
moment.locale("en-gb");

const MyTimeSheet = ({
  selectedTabId,
  selectedPeriod,
  duplicateTimesheet = false,
  actualSummaryData,
}) => {
  const queryClient = useQueryClient();
  const history = useHistory();
  const dispatch = useDispatch();
  const higherOfficialsList = useSelector((state) => getHigherOfficials(state));
  const CEO = (() => {
    const val = getEmailsByRole(higherOfficialsList, "CEO");
      return Array.isArray(val) ? val : val ? [val] : [];
  })();
  const selectedPeriodToDate = periodToDate(selectedPeriod);

  const [copyWeekTimesheet, setCopyWeekTimesheet] = React.useState(null);
  const [isCopying, setIsCopying] = React.useState(false);
  const [loadingActualSummary, setLoadingActualSummary] = useState(false);

  const {
    date,
    week,
    currentWeek,
    edit,
    setEdit,
    currentNiceWeekRange,
    disabledDate,
    handleNextWeek,
    handlePreviousWeek,
    onChange,
    setPersonInCharge,
    personIncharge,
  } = useWeekData(selectedPeriodToDate);

  const { getTimesheet, postTimesheet, updateTimesheet } = queryKeys;

  const userList = useSelector(getUserList);

  const userInfo = useSelector((state) => getUserInfo(state));

  const cachedTimesheets = useSelector(getCachedTimesheets);

  const cachedTimeSheet = cachedTimesheets?.[week] || []; // get cached timesheet for the week

  const currentUser = userList.find((user) => user.userid === userInfo.userid);

  const country = currentUser?.managingoffice?.[0];

   const OfficeSuperVisorId = currentUser?.OfficeSupervisorId || null;

  const currentUserEmployeeId = userList?.find(
    (user) => user?.userid === currentUser?.userid
  )?.employeeid;

  const OfficeSuperVisorUserId = userList?.find(
    (user) =>
      user.employeeid ===
      (currentUser?.userid === CEO
        ? currentUserEmployeeId
        : OfficeSuperVisorId)
  )?.userid;

  const chargeOutRate = currentUser?.chargeoutrate
    ? parseInt(currentUser?.chargeoutrate)
    : 0;

  const {
    data: timesheetDataRes,
    isLoading,
    isFetching,
    isFetched,
  } = useFetch(
    `${getTimesheet.key}-week:${week}`,
    `${getTimesheet.url}?week=${week}&employeeId=${userInfo.employer_id}`,
    {
      enabled: !!week,
    }
  );

    const clientId = useSelector(getClientid);
      const userRoleId = useSelector(getUserRoleId);
    
      // Calculate week start and end dates
      const weekStart = moment(currentWeek, "YYYYMMMDD");
      const weekEnd = moment(currentWeek, "YYYYMMMDD").add(6, "days");
    
      // Fetch holidays
      const { key: holidayKey, url: holidayUrl } = queryKeys.getHolidayList(clientId);
      const { data: holidayDataRes } = useFetch(
        [holidayKey, weekStart, weekEnd],
        holidayUrl,
        { enabled: !!clientId },
        { start_date: weekStart, end_date: weekEnd }
      );
    
      // Fetch leaves
      const { key: leaveKey, url: leaveUrl } = queryKeys.getLeaveList(
        clientId,
        userInfo?.userid
      );
      const leaveParams = {
        status_id: "",
        officesupervisorid: [""],
        selected_role_id: userRoleId,
        start_date: weekStart,
        end_date: weekEnd,
      };
      const { data: leaveDataRes } = useFetch(
        [leaveKey, weekStart, weekEnd],
        leaveUrl,
        { enabled: !!clientId },
        leaveParams
      );
    
      // Filter holidays and leaves
      const holidays = holidayDataRes?.response?.filter((holiday) =>
        holiday?.location_id?.includes(currentUser?.baselocationid)
      );
      
      const leaves =
        leaveDataRes?.response?.leaves?.filter(
          (leave) =>
            leave.userid === userInfo.userid &&
            leave?.status_id === "5" &&
            leave?.having_cancel_request === "0"
        ) || [];
        
    
    const hasHolidayOrLeave = holidays?.length > 0 || leaves?.length > 0;
      const isDraft = timesheetDataRes?.response?.response?.status === "draft" ;
    
       let apentry = {
        "thu": 0,
        "ncClient": null,
        "engagement": "ap",
        "actual_to_date": "",
        "tue": 0,
        "approval": {},
        "sat": 0,
        "sum": 0,
        "mon": 0,
        "sun": 0,
        "task": "",
        "declined": {},
        "wed": 0,
        "claims": [],
        "subEngagement": null,
        "client": "ap",
        "currentWeek": "",
        "fri": 0,
        "remarks": "",
        "personInCharge": "",
        "budget": "",
        "status": "approved"
    }
    useEffect(() => {;
      if (
         (isDraft && hasHolidayOrLeave) &&
        timesheetDataRes?.response?.response?.timeSheet &&
        !timesheetDataRes?.response?.response?.timeSheet.some(entry => entry.client === "ap")
      ) {
        timesheetDataRes?.response?.response?.timeSheet.push(apentry);
      }
    }, [isDraft, timesheetDataRes]);
    
  const timeSheetStatus =
    timesheetDataRes?.response?.response?.status || ONGOING;

  const updateableTimesheet =
    timeSheetStatus === WITHDRAWN || timeSheetStatus === DRAFT;

  const [form] = Form.useForm();

  const { mutate: submitTimesheet, isLoading: isSubmitting } = useMutate(
    postTimesheet.key,
    postTimesheet.url
  );

  const { mutate: update, isLoading: isUpdating } = useUpdate(
    updateTimesheet.key,
    updateTimesheet.url
  );

  const getActualSummary = async (engagementId, userId) => {
    try {
      const { data } = await CALL_API(
        `/insyts/timesheet/actualsummary?engagementId=${engagementId}&userId=${userId}`,
        "get"
      );

      return data;
    } catch (error) {
      console.error("Failed to fetch actualToDate:", error);
      return null;
    }
  };

   const onSubmit = async (
    values,
    draft = false,
    skipActualSummary = false,
    originalTimeSheet
  ) => {
    let timeSheetData = generateTimeSheetData(values, draft);
    if (originalTimeSheet) {
      timeSheetData = generateTimeSheetData(
        values,
        false,
        originalTimeSheet,
        true,
        false,
        true
      );
    }
    if (!draft && !isChargeAbleAmtValid(timeSheetData)) {
      return false;
    }
    const data = {
      week: week,
      employeeId: userInfo.userid,
      employeeName: userInfo.name,
      departementId: userInfo.department,
      rate: chargeOutRate,
      timeSheet: timeSheetData,
      status: draft ? DRAFT : PENDING,
      country: country,
      // totalChargeableHours: filteredResponse,
      timesheetSubmittedDate: draft
      ? null
      : timesheetDataRes?.response?.response?.timesheetSubmittedDate ||
        moment().format("DD-MM-YYYY HH:mm:ss"),
    };
    data.timeSheet = data.timeSheet.map((entry) => {
      const currentStatus = entry?.status?.toLowerCase?.();
      // ✅ SAVE AS DRAFT logic
      if (draft) {
        return {
          ...entry,
          status: currentStatus === "withdrawn" ? "draft" : entry.status,
          isNew: typeof entry.isNew === "boolean" ? entry.isNew : true,
        };
      }

      // ✅ SUBMIT logic
      let newStatus = entry.status;

      if (currentStatus === "withdrawn" || currentStatus === "draft") {
        newStatus = "pending";
      }
      // keep "approved" and "declined" as-is

      return {
        ...entry,
        status: newStatus,
        isNew: typeof entry.isNew === "boolean" ? entry.isNew : false,
      };
    });
    if (!draft) {
      const missingTask = timeSheetData.some((entry) => {
        const currentStatus = entry?.status?.toLowerCase?.();
        const isApproved = currentStatus === "approved";
        const isExisting = !!entry._id || !!entry.id; // adjust based on your DB field

        // Skip validation for approved or existing (legacy) entries
        if (isApproved || isExisting) return false;

        // Require task for new or editable entries
        return !entry.task || entry.task === undefined || entry.task === "";
      });

      if (missingTask) {
        notification.warning({
          message: "Task selection required for editable timesheets while submitting",
        });
        return;
      }
    }
    const existingSubmittedDate = timesheetDataRes?.response?.response?.timesheetSubmittedDate;
    if (updateableTimesheet) {
      const updatedData = {
        ...timesheetDataRes?.response?.response,
        status: draft ? DRAFT : PENDING,
        timeSheet: data.timeSheet,
        ...(!draft && !existingSubmittedDate ? { timesheetSubmittedDate: moment().format("DD-MM-YYYY HH:mm:ss") } : {}),
      };
      update(updatedData, {
        onSuccess: (res) => {
          queryClient.invalidateQueries(`${getTimesheet.key}-week:${week}`);
          queryClient.invalidateQueries(
            `${getTimesheet.key}-week:${week}-status:${
              draft ? "draft" : "pending"
            }`
          );
          notification.success({
            message: draft
              ? "Timesheet Saved Successfully"
              : updateableTimesheet
              ? "Timesheet Updated Successfully"
              : "Timesheet Submitted Successfully",
          });
        },
      });
    } else {
      submitTimesheet(data, {
        onSuccess: (res) => {
          queryClient.invalidateQueries(
            `${getTimesheet.key}-week:${week}-status:${
              draft ? "draft" : "pending"
            }`
          );
          queryClient.invalidateQueries(`${getTimesheet.key}-week:${week}`);
          notification.success({
            message: draft
              ? "Timesheet Saved Successfully"
              : "Timesheet Submitted Successfully",
          });
        },
      });
    }
    if (!skipActualSummary) {
      setLoadingActualSummary(true);
      try {
        const payloads = [];
        const groupedByEngagement = {};

        values.forEach((item) => {
          const engagementId = item.engagement;
          if (!groupedByEngagement[engagementId]) {
            groupedByEngagement[engagementId] = [];
          }
          groupedByEngagement[engagementId].push(item);
        });

        // Process each engagementId sequentially using for...of
        for (const [engagementId, items] of Object.entries(
          groupedByEngagement
        )) {
          const resourceId = items[0].resourceId;
          const status = items[0].status || "pending";

          const actualSummaryData = await getActualSummary(
            engagementId,
            userInfo.userid
          );

          const hasExisting =
            (actualSummaryData?.actualTimesheet || []).length > 0;

          const existingEntries = hasExisting
            ? actualSummaryData.actualTimesheet.filter(
                (entry) =>
                  entry.resourceId === resourceId && entry.week !== week
              )
            : [];

          const payload = {
            engagementId,
            userId: userInfo.userid,
            actualTimesheet: [...existingEntries],
          };

          items.forEach((item) => {
            payload.actualTimesheet.push({
              resourceId: item.resourceId ?? null,
              week: week,
              sum: item.sum || 0,
              actualhours: item.actual_to_date ?? 0,
              status: item.status || "pending",
            });
          });

          payloads.push({
            method: hasExisting ? "patch" : "post",
            data: payload,
          });
        }

        // Send all API requests in parallel
        const responses = await Promise.all(
          payloads.map(({ method, data }) =>
            CALL_API("insyts/timesheet/actualsummary", method, data)
          )
        );
      } catch (error) {
        console.error("Error submitting actual summaries:", error);
      } finally {
        setLoadingActualSummary(false);
      }
    }
  };

  useEffect(() => {
    dispatch(toggleProcessingModal(isUpdating || isSubmitting));
  }, [isUpdating, isSubmitting]);

  const {
    timeSheet,
    setTimeSheet,
    generateTimeSheetData,
    handleAddMore,
    handleAddMoreClaim,
    handleClearClaim,
    handleResetClaim,
    handleRemoveClaim,
    handlePersonInCharge,
    handleClearTimesheet,
    handleSaveTimesheet,
    isChargeAbleAmtValid,
    handleSubmitTimesheet,
  } = useTimesheetfns({
    personIncharge,
    OfficeSuperVisorUserId,
    currentWeek,
    form,
    setPersonInCharge,
    week,
    timesheetDataRes,
    onSubmit,
    isFetched,
    duplicateTimesheet,
  });

  const editableTimesheet =
    timeSheetStatus === WITHDRAWN ||
    timeSheetStatus === ONGOING ||
    timeSheetStatus === DRAFT;

  useEffect(() => {
    if (
      cachedTimeSheet.length > 0 &&
      !timesheetDataRes?.response?.response?.timeSheet
    ) {
      setTimeSheet(cachedTimeSheet);
      form.setFieldsValue(cachedTimeSheet);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cachedTimeSheet, timesheetDataRes]);

  const pasteTimeSheet = async (week, date) => {
    setIsCopying(true);
    const accessToken = window.localStorage.getItem("token");

    try {
      const response = await queryClient.fetchQuery({
        queryKey: `${getTimesheet.key}-week:${week}`,
        queryFn: async () => {
          return await apiInstance({
            method: "GET",
            url: `${getTimesheet.url}?week=${week}&employeeId=${userInfo.employer_id}`,
            headers: {
              Tymeplusjwt: accessToken,
            },
          })
            .then((res) => {
              return res.data;
            })
            .catch((err) => {
              return err.response;
            });
        },
      });

      const timeSheetResponse =
        response?.response?.response?.timeSheet || false;

      if (timeSheetResponse) {
        // onChange(date);

        const statusRemovedTimesheet = timeSheetResponse.map((value) => {
          return {
            ...value,
            status: "",
            approval: {},
            declined: {},
          };
        });

        setTimeSheet(statusRemovedTimesheet);
        form.setFieldsValue(statusRemovedTimesheet);
      } else {
        notification.error({
          // message: `Timesheet for week ${week} not found`,
          message: `Timesheet Not Found`,
        });
      }
      setCopyWeekTimesheet(null);
      setIsCopying(false);
    } catch (error) {
      setIsCopying(false);
      console.error("error", error);
    }
  };

  const handlePasteTimesheet = (date) => {
    var weekStart = date.clone().startOf("isoWeek");
    var weekEnd = date.clone().endOf("isoWeek");

    setCopyWeekTimesheet(date);
    pasteTimeSheet(generateTimesheetWeek(weekStart, weekEnd), weekStart);
  };

  return (
    <Form
      form={form}
      initialValues={timeSheet}
      layout="vertical"
      onFinishFailed={() => {
        notification.error({
          message: "Please fill all the required fields",
        });
      }}
    >
      <div className="timesheet-header">
        <div>
          <img
            src={LeftIcon}
            alt="left"
            className="left-icon"
            onClick={handlePreviousWeek}
          />
          <img
            src={RightIcon}
            alt="right"
            className="right-icon"
            onClick={handleNextWeek}
          />
          <span className="d-inline-flex justify-content-center align-items-center gap-2">
            <span className="date">Date:</span>{" "}
            {edit ? (
              <ClickAwayListener onClickAway={() => setEdit(false)}>
                <div className="position-relative">
                  <ConfigProvider locale={en_GB}>
                    <DatePicker
                      onChange={onChange}
                      picker="week"
                      value={date}
                      open={true}
                      disabledDate={disabledDate}
                    />
                  </ConfigProvider>
                </div>
              </ClickAwayListener>
            ) : (
              <div className="current-week me-2" onClick={() => setEdit(true)}>
                {currentNiceWeekRange}
              </div>
            )}
          </span>
        </div>

        <div className="d-inline-flex justify-content-center align-items-center gap-2 flex-wrap">
          {/* <Button
            type="primary"
            className="history-button"
            onClick={() => history.push("/timesheet-history")}
          >
            History
          </Button> */}
        </div>
      </div>
      <Spin spinning={isLoading || isCopying}>
        <div className="mb-4">
          <TimeSheetOverView timeSheet={timeSheet} />
        </div>

        {/* {timeSheetStatus === ONGOING ? (
          <div className="d-inline-flex justify-content-center align-items-center gap-2 mb-2">
            <span className="duplicate-week">Duplicate Week for Cloning: </span>
            <span>
              <div className="position-relative">
                <ConfigProvider locale={en_GB}>
                  <DatePicker
                    picker="week"
                    value={copyWeekTimesheet}
                    onChange={handlePasteTimesheet}
                    disabledDate={disabledDate}
                    placeholder="Select"
                  />
                </ConfigProvider>
              </div>
            </span>
          </div>
        ) : null} */}

        <TimeSheet
          selectedTabId={selectedTabId}
          timesheetgetdata={timesheetDataRes?.response?.response}
          editable={editableTimesheet}
          data={timeSheet}
          onSubmit={onSubmit}
          extraActions={{
            handlePersonInCharge,
            handleClearTimesheet,
            handleSaveTimesheet,
            handleAddMoreClaim,
            handleClearClaim,
            handleResetClaim,
            handleRemoveClaim,
          }}
          week={week}
          holidays={holidays}
          leaves={leaves}
        />

        {editableTimesheet && (
          <div className="d-flex justify-content-start align-items-center gap-2 mt-4">
            <Button type="primary" className="add-more" onClick={handleAddMore}>
              Add More
            </Button>
          </div>
        )}
      </Spin>

      <TimeSheetFooterHint />

      <div className="d-flex justify-content-start align-items-center gap-2 mt-4">
        {editableTimesheet && !isLoading && !isFetching && !isCopying && (
          <Button
            type="primary"
            onClick={handleSubmitTimesheet}
            loading={isSubmitting || isUpdating || loadingActualSummary}
            className="submit-button"
          >
            Submit
          </Button>
        )}
        {/* <Button
            type="primary"
            htmlType="submit"
            loading={isSubmitting || isUpdating}
            className="submit-button"
          >
            Submit
          </Button> */}
        {/* <Button
          type="primary"
          className="close-button"
          onClick={() => {
            history.push("/timesheet");
          }}
        >
          Close
        </Button> */}
      </div>
    </Form>
  );
};

const mapStateToProps = (state) => ({
  actualSummaryData: getActualSummaryData(state),
});

export default connect(mapStateToProps, null)(MyTimeSheet);
